var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatAlt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 6.66683H15.8333C16.7538 6.66683 17.5 7.41302 17.5 8.3335V13.3335C17.5 14.254 16.7538 15.0002 15.8333 15.0002H14.1667V18.3335L10.8333 15.0002H7.5C7.03976 15.0002 6.6231 14.8136 6.32149 14.512M6.32149 14.512L9.16667 11.6668H12.5C13.4205 11.6668 14.1667 10.9206 14.1667 10.0002V5.00016C14.1667 4.07969 13.4205 3.3335 12.5 3.3335H4.16667C3.24619 3.3335 2.5 4.07969 2.5 5.00016V10.0002C2.5 10.9206 3.24619 11.6668 4.16667 11.6668H5.83333V15.0002L6.32149 14.512Z",
    stroke: "#F2C94C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAlt2);
export default __webpack_public_path__ + "static/media/chat-alt-2.25f67acf5ad00e41c0ce04e6508dbe31.svg";
export { ForwardRef as ReactComponent };